<!-- Start footer -->
<footer class="custom-footer main-full  py-5 position-relative">
    <div class="container mt-3 footerdesign">
        <div class="row">
            <div class="col-md-5">
                <img src="assets/images/svg/figma2.png" width="" height="" (click)="onClick5()" style="cursor: pointer;" title="footer-image" alt="footer-image">
                <div class="mt-4">
                    <p class="footer-content" style="width: 271px; color: black;">We at BuyMore Infotech aim to provide the best technology solutions at a competitive
                        price to our customers. We provide an end-to-end solution fast without compromising on
                        quality.</p>
                </div>
                <!-- <div class="d-flex mt-1">
                    <a><img src="assets/images/svg/q.png" title="footer-image" alt="footer-image"></a>
                    <a class="ms-3"   target="_blank" title="linkedIn" ><img src="assets/images/svg/in.png" title="footer-image" alt="footer-image"></a>
                    <a class="ms-3" target="_blank" title="instagram" ><img src="assets/images/svg/insta.png" title="footer-image" alt="footer-image"></a>
                    <a class="ms-3"  target="_blank" title="youtube"><img src="assets/images/svg/u.png" title="footer-image" alt="footer-image"></a>
                    <a class="ms-3" ><img src="assets/images/svg/f.png" title="footer-image" alt="footer-image"></a>
                    <a class="ms-3"><img src="assets/images/svg/twi.png" title="footer-image" alt="footer-image"></a>
                </div> -->

            </div>
            <div class="col-md-3">
                <p class="heading1" style="color: black;">Quick Link</p>
                <p class="mt-4" style="color: black; cursor: pointer;" (click)="onClick5()">Home</p>
                <p class="mt-3" style="color: black; cursor: pointer;" (click)="onClick2()">Services</p>
                <p class="mt-3" style="color: black; cursor: pointer;" (click)="onClick1()">Track Orders</p>
                <p class="mt-3" style="color: black; cursor: pointer;" (click)="onClick3()">About Us</p>
                <p class="mt-3" style="color: black; cursor: pointer;" (click)="onClick4()">Contact Us</p>
            </div>
            <div class="col-md-4">
                <h4 class="reach mb-4" style="color: black;">Reach us</h4>
                <div class="col-md-12 mt-5" style="display: contents;">

                    <span class="mt-5"><img src="assets/images/svg/email1.png" title="Image from Footer" alt="email" height="25px" width="20px"></span><span class="ms-2 mt-3" style="color: black;">support@buymoreinfotech.com</span>
                    <p></p>
                    <span class="mt-3"><img src="assets/images/svg/phone1.png" title="Image from Footer" alt="phone" height="25px" width="20px"></span> <span class="ms-2 mt-3" style="color:black;">+91 7949107779</span>
                    <p></p>
                    <div class="row mt-3">
                        <div class="col-md-1">
                            <span><img src="assets/images/svg/location1.png" title="Image from Footer" alt="location" height="25px" width="20px"></span>
                        </div>
                        <div class="col-md-10 loca_Icon">
                            <span style="color: black;">Ground Floor, Left Wing, 106/A 4th C Cross, 20th Main Rd, Koramangala Industrial Layout, Bengaluru, Karnataka 560095</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- <div class="col-md-12 container laptop">
        <div class="mt-5 row footerMargin d-flex justify-content-between">
            <div class="allRights col-md-6">
                <h5  class="mt-4 year" style="color: white;">&#169; {{currentYear}} BUYMOREANALYTIX All rights reserved</h5>
            </div>
            <div class="termsCondition mt-4 col-md-6" id="foterrr">
                <a  routerLinkActive="router-link-active"
                    style="color: #C7C9D1; cursor: pointer;" class="mt-4 mb-1 mr-2 ml-2" title="Conditions"  (click)="onClick9()" target="_blank">Terms & Condition </a><span id="symbol1">|</span>
                <a  routerLinkActive="router-link-active" style="color: #C7C9D1; cursor: pointer;"
                    class="mt-4 mb-1 mr-2 ml-2" title="Privacy"  (click)="onClick11()" target="_blank">Privacy Policy </a><span id="symbol1">|</span>
                <a  routerLinkActive="router-link-active"
                    style="color: #C7C9D1;" class="mt-4 mb-1 mr-2 ml-2" title="Sitemap" target="_blank">Sitemap </a><span id="symbol1">|</span>
                <a  routerLinkActive="router-link-active" style="color: #C7C9D1;"
                    class="mt-4 mb-1 mr-2 ml-2" title="Disclaimer" target="_blank">Disclaimer </a>
            </div>
        </div>
    </div>
    <div class="col-md-12 mobile">
        <div class=" mt-5" id="foterrr">
            <div class="allRights d-flex">
                <h5  class="mt-2 year" style="color: white;">&#169; {{currentYear}} BUYMOREANALYTIX All rights reserved</h5>
            </div>
            <div class="termsCondition d-flex  mt-2">
                <a  routerLinkActive="router-link-active"
                    style="color: #C7C9D1; cursor: pointer;" class="mt-2 mb-1 mr-2 ml-2" title="Conditions"  (click)="onClick9()" target="_blank">Terms & Condition </a><span id="symbol">|</span>
                <a  routerLinkActive="router-link-active" style="color: #C7C9D1; cursor: pointer;"
                    class="mt-2 mb-1 mr-2 ml-2" title="Privacy"  (click)="onClick11()" target="_blank">Privacy Policy </a><span id="symbol">|</span>
                <a  routerLinkActive="router-link-active"
                    style="color: #C7C9D1;" class="mt-2 mb-1 mr-2 ml-2" title="Sitemap" target="_blank">Sitemap </a><span id="symbol">|</span>
                <a  routerLinkActive="router-link-active" style="color: #C7C9D1;"
                    class="mt-2 mb-1 mr-2 ml-2" title="Disclaimer" target="_blank">Disclaimer </a>
            </div>
        </div>
    </div> -->


</footer>